
import { Dates } from '../../../packages/dates';
import Utils from '../../../utils/Utils';

export function dateIsToday(date){
    return Utils.now(true).isSame(new Dates().unix(date), 'days');
}

export function calculateProgress(dateBeginUnix, dateEndUnix){
    const nowMoment = Utils.now(true);
    const beginMoment = new Dates().unix(dateBeginUnix);
    const endMoment = new Dates().unix(dateEndUnix);
    const diffBetweenNowToBegin = nowMoment.diff(beginMoment);
    const diffBetweenBeginToEnd = beginMoment.diff(endMoment);
    const progress = Math.abs( ( diffBetweenNowToBegin * 100 ) / diffBetweenBeginToEnd );
    return progress <= 100 ? progress : 100 ;
}



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/Helpers/Utils.js